module.exports = __webpack_public_path__ + "img/logo_black.ee0621b6.png";